import AsyncStorage from "@react-native-async-storage/async-storage";

interface IStorageUtil {
  setItem(key: string, value: any): Promise<void>; // Mudei o type de value para 'any'
  getItem<T>(key: string): Promise<T | null>; // Adicionado um generic type T
  removeItem(key: string): Promise<void>;
}

const setItem: IStorageUtil["setItem"] = async (key, value) => {
  try {
    const jsonValue = JSON.stringify(value); // Convertendo o valor para JSON string
    await AsyncStorage.setItem(key, jsonValue);
  } catch (error) {
    console.error("Error saving data to AsyncStorage:", error);
    throw error;
  }
};

const getItem: IStorageUtil["getItem"] = async <T>(
  key: string
): Promise<T | null> => {
  try {
    const jsonValue = await AsyncStorage.getItem(key);
    if (jsonValue === null) return null;
    return JSON.parse(jsonValue); // Convertendo a JSON string de volta para objeto
  } catch (error) {
    console.error("Error retrieving data from AsyncStorage:", error);
    throw error;
  }
};

const removeItem: IStorageUtil["removeItem"] = async (key) => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing data from AsyncStorage:", error);
    throw error;
  }
};

const onlyDigits = (s: string): string => (s || "").replace(/\D/g, "");

const formatByMask = (raw: string, mask: string) => {
  const digits = onlyDigits(raw);
  let di = 0;
  let out = "";

  for (let i = 0; i < mask.length; i++) {
    const m = mask[i];
    if (m === "9") {
      if (di < digits.length) {
        out += digits[di++];
      } else {
        break; // sem dígitos suficientes, para aqui
      }
    } else {
      // caractere fixo da máscara (., -, /, espaço, parênteses etc.)
      if (di < digits.length) out += m;
      else break;
    }
  }
  return out;
};

const unmask = (value: string): string => {
  return onlyDigits(value);
};

export default {
  setItem,
  getItem,
  removeItem,
  formatByMask,
  onlyDigits,
  unmask,
};
